/**
 * Block: Role
 */

class Role {
	constructor(el) {
		this.el = el;
		this.items = this.el.querySelectorAll('.em-role__role-item');
		this.mobileClick = this.mobileClick.bind(this);
	}

	mobileClick() {
		if (this.items.length) {
			this.items.forEach((item) => {
				item.addEventListener('click', (e) => {
					const { target } = e;

					if (target.tagName !== 'A') {
						const parent = target.closest('.em-role__role-item');
						if (parent.classList.contains('selected')) {
							parent.classList.remove('selected');
						} else {
							parent.classList.add('selected');
						}
					}
				});
			});
		}
	}

	init() {
		this.el.classList.add('loaded');
		this.mobileClick();
	}
}

const role = {
	init() {
		const roleBlocks = document.querySelectorAll('.em-role');
		if (roleBlocks.length) {
			roleBlocks.forEach((block) => {
				const _role = new Role(block);
				_role.init();
			});
		}
	},
};

role.init();
